import styled from 'styled-components'
import { SubmitButton } from 'formik-antd'
import { margin, screen, typography, height, padding, color, borderRadius } from '@libs/theme/mixins'

const ContinueButton = styled(SubmitButton)`
	margin-top: ${margin('xl')};
	align-self: center;
	width: 300px;
	${screen.lte.xxs`
		width: 100%;
	`}
`

const UsersGrid = styled.div`
	display: grid;
	grid-template-columns: auto auto;
	grid-column-gap: ${margin('xxs')};
	align-items: center;
`

const RoleTag = styled.div`
	${typography('sm')}
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	font-weight: 500;
	height: ${height('xs')};
	padding: ${padding(0, 'sm')};
	background: ${color(['gray', '100'])};
	border: 1px solid ${color(['primary', '200'])};
	border-radius: ${borderRadius('sm')};
`

export default { ContinueButton, RoleTag, UsersGrid }
